import React from 'react';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import Headline from '../components/atoms/Headline';
import { pendingOrder, getPayeverFrame, checkPayeverStatus } from '../actions';
import SimpleButton from '../components/atoms/SimpleButton';
import { contentChange } from '../actions/content';
import { resetPayment } from '../actions/status';
import { restartPayever, resetPayever } from '../actions/payever';
// import { setCustomerForm } from '../actions/customer';
import moment from 'moment';
import 'moment/locale/de';


var AppConfig = require('../config.json');

class PayeverView extends React.Component {
    constructor(props) {
      super(props);
      this.makePayeverRequest = this.makePayeverRequest.bind(this);
      this.setPendingOrder = this.setPendingOrder.bind(this);
      this.getPayeverStatus = this.getPayeverStatus.bind(this);
      this.startOverClick = this.startOverClick.bind(this);
      this.noPayeverClick = this.noPayeverClick.bind(this);
      this.setVisible = this.setVisible.bind(this);
      this.goExternal = this.goExternal.bind(this);
      this.processedAndCheckout = this.processedAndCheckout.bind(this);

      
      this.nextStep = this.nextStep.bind(this);
      this.state = {
        payeverRequestSent: false,
        status: 'requesting',
        hidden: false
      };
    }
    componentDidMount() {

      if(!this.props.payever.processed) {
        if (this.props.payever.orderId === 0) {
          this.props.setTimeout(this.setPendingOrder, 200);
        } else if (this.props.payever.orderId !== 0 && this.props.payever.id === 0) {
          this.props.setTimeout(this.makePayeverRequest, 200);
        } else if(this.props.payever.orderId !== 0 && this.props.payever.id !== 0) {
          this.props.setTimeout(this.getPayeverStatus, 200);
        }
      }
      // if (this.props.status.order.isset) {
      //   this.props.dispatch(setCustomerForm(this.props.status.order.form));
      // }
      

    }

    goExternal() {
       window.location.href = this.props.payever.frame;
    }
    processedAndCheckout() {
      // this.props.dispatch(contentChange(AppConfig.links.checkout.url));
      this.props.dispatch(contentChange(AppConfig.links.finished.url));
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.props.payever.isCancelled) {
        if (prevProps.payever.isCancelled) {
          return;
        }
        this.setState({ status: 'notpossible'});
        this.props.setTimeout(this.setVisible, 200);
        return;
      }
      if (!prevProps.payever.generalError && this.props.payever.generalError) {
        this.setState({ status: 'notpossible'});
        this.props.setTimeout(this.setVisible, 200);
        return;
      }
      if(!this.props.payever.checkout && this.props.payever.processed && this.props.payever.orderId !== 0 && this.props.payever.id !== 0) {
        this.props.setTimeout(this.processedAndCheckout, 200);
        return;
      }
      if (this.state.status === 'notpossible' || this.state.status === 'external') {
        return;
      }
      if (this.props.payever.orderId !== 0 && this.props.payever.id === 0 && !this.props.payever.processed) {
        this.props.setTimeout(this.makePayeverRequest, 100);
      }
      if(!this.props.payever.processed && this.props.payever.id!==0) {
        this.setState({ status: 'external'});
        if(this.props.payever.frame!=='' && prevProps.payever.frame==='') {
          this.props.setTimeout(this.goExternal, 120);
        }
        
      }
    }


    setVisible() {
        this.setState({ visible:true });
    }

  getPayeverStatus() {
    if (this.props.payever.processed ||
        this.props.payever.isError ||
        this.props.payever.isCancelled ||
        this.props.payever.isSuccess ||
        this.props.payever.isPending
    ) {
      return;
    }
    this.props.checkPayeverStatus(
      {
        id: this.props.payever.id,
        command: 'check'
      }
    );
  }

    
    setPendingOrder() {
      var street = this.props.status.order.form.strasse;
      if(this.props.status.order.form.hausnummer!==street) {
        street = street.concat(" ", this.props.status.order.form.hausnummer);
      }
      var form = {
          projectsId: this.props.status.project.id,
          bundlesId: this.props.status.bundle.id,
          articles: this.props.status.options.articles,
          paymentType: this.props.status.payment.type,
          paymentRuntime: 0,
          paymentAmount: 0,
          anrede: this.props.status.order.form.anrede,
          vorname: this.props.status.order.form.vorname,
          nachname: this.props.status.order.form.nachname,
          strasse: street,
          plz: parseInt(this.props.status.order.form.plz, 10),
          ort: this.props.status.order.form.ort,
          land: "DE",
          email: this.props.status.order.form.email,
          telefon: this.props.status.order.form.telefon,
          fax: this.props.status.order.form.fax,
          kontoinhaber: this.props.status.order.form.kontoinhaber,
          bank: this.props.status.order.form.bank,
          iban: this.props.status.order.form.iban,
          bic: this.props.status.order.form.bic,
          support: this.props.status.order.form.support,
          customdata: this.props.status.order.form.customdata,
          upload: this.props.status.order.form.upload,
          pending: true,
          isDep: this.props.status.project.isDep ? 1 : 0,
          payever: {}
        };
        if(AppConfig.inputoptions.birthdatecustomer) {
          form.geburtstag = moment
            .utc(this.props.status.order.form.geburtstag, AppConfig.dateFormat)
            .unix();
        }
        if(!this.props.status.project.teachers) {
          form.namekind = this.props.status.order.form.vornamekind+' '+this.props.status.order.form.nachnamekind;
          if(this.props.status.order.form.geburtstagkind!=="") {
            form.geburtstagkind = moment
            .utc(this.props.status.order.form.geburtstagkind, AppConfig.dateFormat)
            .unix();
          } else {
            form.geburtstagkind = "";
          }

        } else {
          form.schoolname = this.props.status.order.form.schoolname;
        }
        this.setState({ payeverRequestSent: true });
        this.props.pendingOrder(form);
    }
    makePayeverRequest() {
        this.props.payeverSubmit({
          orderId: this.props.payever.orderId
        });
      
    }

    noPayeverClick() {
      this.props.dispatch(resetPayever());
      this.props.dispatch(resetPayment());
      this.props.dispatch(contentChange(AppConfig.links.payment.url));
    }
    startOverClick() {
      this.setState({ status:'requesting' });
      this.props.dispatch(restartPayever());
    }

    nextStep() {
      this.props.dispatch(contentChange(AppConfig.links.checkout.url));
    }

    render () {
        
        return (
          <div
            className={`contentview payever${this.state.hidden
          ? ' hidden'
          : ''}${this.state.status !== '' ? ' reveal' : ''}${this.state.visible ? ' visibleitems' : ''}`}
          >
            


            {
              this.state.status==='notpossible' &&
                <div className="notpossible fadein">
                  <Headline typeOf="h2" alignment="center">
                    {this.props.payever.isCancelled?"Zinia Ratenkauf abgebrochen.":"Zinia Ratenkauf nicht möglich."}
                  </Headline>
                  {
                    this.props.payever.isCancelled?
                    <div className="resultpayever">
                      <strong>Der Vorgang zum Zinia Ratenkauf wurde abgebrochen.</strong>
                      <p>Sollten Sie den Abbruch nicht selbst veranlasst haben, wenden Sie sich bitte an GfdB.<br/>Ansonsten wählen Sie bitte eine andere Vertragsart. Vielen Dank.</p>
                    </div>
                    :
                    <div className="resultpayever">
                      <strong>Die von Ihnen gewählte Zahlart kann leider nicht angeboten werden.</strong>
                      <p>Wenden Sie sich bitte an GfdB oder wählen Sie eine andere Vertragsart. Vielen Dank.</p>
                  </div>
                  }
                  
                  <div className="backbtn">
                    <SimpleButton
                      children="Bitte wählen Sie eine andere Vertragsart"
                      onClick={this.noPayeverClick}
                    />
                  </div>
                </div>
            }

            {
                this.state.status==='requesting' &&
                <div className="connecting">
                  <Headline typeOf="h2" alignment="center">
                    Verbindung mit Zinia/Payever wird hergestellt
                  </Headline>
                  <div className="spinner">
                    <div className="mnml-spinner" />
                  </div>
                </div>
            }

            {
                this.state.status==='external' &&
                <div>
                  <Headline typeOf="h2" alignment="center">
                    Vorgang noch nicht abgeschlossen
                  </Headline>
                  <div className="resultpayever external">
                  <strong>Der Vorgang zum Zinia Ratenkauf ist noch nicht beendet.</strong>
                      <p>Sie wurden automatisch zu den Eingabe-Formularen der Zinia Ratenkauf Bank weitergeleitet. Falls Sie den Vorgang noch nicht abgeschlossen haben und nicht mehr dorthin zurückkehren können, starten Sie den Prozess bitte neu oder wählen Sie eine andere Zahlart. Vielen Dank.</p>
                  </div>
                  <div className="btns">
                    <div className="backbtn restartbtn">
                      <SimpleButton
                        children="Den Ratenkauf Vorgang erneut starten"
                        onClick={this.startOverClick}
                      />
                    </div>
                    <div className="backbtn">
                      <SimpleButton
                        children="Oder wählen Sie eine andere Zahlart"
                        onClick={this.noPayeverClick}
                      />
                    </div>
                  </div>
                </div>
            }
          </div>
        );
    }

}




const mapStateToProps = (state) => {
  return {
    payever: state.payever,
    status: state.status
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    checkPayeverStatus: (form) => {
      checkPayeverStatus(form)(dispatch)
    },
    payeverSubmit: (form) => {
      getPayeverFrame(form)(dispatch);
    },
    pendingOrder: orderform => {
      pendingOrder(orderform)(dispatch);
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ReactTimeout(PayeverView)
);


// WEBPACK FOOTER //
// ./src/views/PayeverView.js